import { render, staticRenderFns } from "./VehicleAssign.vue?vue&type=template&id=c56f9132&scoped=true&"
import script from "./VehicleAssign.vue?vue&type=script&lang=js&"
export * from "./VehicleAssign.vue?vue&type=script&lang=js&"
import style0 from "./VehicleAssign.vue?vue&type=style&index=0&id=c56f9132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56f9132",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
installComponents(component, {VAutocomplete,VBtn,VCard,VChip,VChipGroup})
